/**
 * Плитка вида процесса: значок, название, описание, шеврон → форма /processes/new/[id].
 * Одна и та же плитка — в «Новом процессе» и в «Быстрых действиях» главной (владелец,
 * 29.10.2026: кнопки на главной не свои, а как в «Процессах» — единый вид на всех экранах).
 */
import { useRouter } from 'expo-router'
import { Stack, Text, YStack } from 'tamagui'

import { useApp } from '../../../i18n'
import { Icon, PressCard } from '../../../ui'
import type { ProcessType } from '../registry'

export function ProcessTypeTile({ pt }: { pt: ProcessType }) {
  const { t } = useApp()
  const router = useRouter()
  return (
    <PressCard flexGrow={1} flexDirection="row" alignItems="center" gap={12} padding={16} minHeight={84} onPress={() => router.push(`/processes/new/${pt.id}`)}>
      <Stack width={42} height={42} flexShrink={0} borderRadius={7} backgroundColor="$primaryBg" alignItems="center" justifyContent="center">
        <Icon name={pt.icon} size={20} color="$primary" />
      </Stack>
      <YStack flex={1} minWidth={0} gap={4}>
        <Text fontSize={13} fontWeight="700" color="$color">
          {t(pt.name)}
        </Text>
        <Text fontSize={11} color="$muted" lineHeight={17}>
          {t(pt.desc)}
        </Text>
      </YStack>
      <Icon name="chevron-right" size={18} color="$tertiary" />
    </PressCard>
  )
}
